import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

interface AuditEntry {
  id: string
  ts: string
  actor_key_id: string | null
  action: string
  target_kind: string | null
  target_id: string | null
  details: Record<string, unknown>
  ip: string | null
}

export function AuditLogPage() {
  const { data, isLoading } = useQuery<AuditEntry[]>({
    queryKey: ['audit'],
    queryFn: () => api<AuditEntry[]>('/api/audit?limit=200'),
    refetchInterval: 30_000,
  })

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Audit log</h1>
        <p className="text-muted-foreground">Admin-only history of state-changing actions.</p>
      </div>

      {isLoading && <Skeleton className="h-40" />}

      <Card>
        <CardHeader><CardTitle className="text-base">Recent events</CardTitle></CardHeader>
        <CardContent className="divide-y">
          {data?.map((e) => (
            <div key={e.id} className="py-2 text-sm grid grid-cols-1 md:grid-cols-[160px_1fr] gap-2">
              <div className="text-xs text-muted-foreground">
                {new Date(e.ts).toLocaleString()}
                {e.ip && <div>{e.ip}</div>}
              </div>
              <div>
                <span className="font-medium">{e.action}</span>
                {e.target_kind && <span className="text-muted-foreground"> · {e.target_kind}</span>}
                {e.target_id && <span className="text-muted-foreground"> · {e.target_id}</span>}
                {Object.keys(e.details).length > 0 && (
                  <pre className="text-xs text-muted-foreground mt-1 whitespace-pre-wrap">
                    {JSON.stringify(e.details, null, 2)}
                  </pre>
                )}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  )
}
